import React, { Suspense } from "react";
import { ApplicationFeature } from "@green0meter/api-client";

import { Loader, RequireFeature } from "@components/common";
import { UserLayout } from "@layouts";
import { CsobAuthPage, CsobFormPage } from "@pages";

export const csobRoutes = [
  {
    path: "csob-auth",
    element: <CsobAuthPage />,
  },
  {
    element: (
      <Suspense fallback={<Loader />}>
        <UserLayout />
      </Suspense>
    ),
    children: [
      {
        path: "/csob/form/:formId",
        element: (
          <RequireFeature features={[ApplicationFeature.CSOB]}>
            <CsobFormPage />
          </RequireFeature>
        ),
      },
    ],
  },
];
